import { Skeleton } from '@thg-commerce/gravity-elements'
import { styled } from '@thg-commerce/gravity-theme'

export const MapSkeleton = styled(Skeleton)`
  height: 100%;
  width: 100%;
`

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  & .gm-style-iw.gm-style-iw-c {
    border-radius: 0px;
    padding: 0px;
    background-color: transparent;
    box-shadow: none;
  }

  & .gm-style-iw-tc {
    display: none;
  }

  & .gm-ui-hover-effect {
    right: 3px !important;
    top: -3px !important;

    > span {
      width: 20px !important;
      height: 20px !important;
    }
  }
  & .gm-style-iw-d {
    overflow: unset !important;
  }
`
